import { Box, Container, Link, Typography } from "@mui/material";

const colors = {
    cream: "#fffaf2",
    sand: "#f7f1e8",
    paper: "rgba(255, 250, 242, 0.9)",
    ink: "#2a2621",
    muted: "rgba(42, 38, 33, 0.68)",
    brown: "#9b7653",
    brownDark: "#6f5136",
};

function SectionTitle({ children }) {
    return (
        <Typography
            component="h2"
            sx={{
                mt: 5,
                mb: 2,
                fontFamily: '"Quicksand", sans-serif',
                fontSize: {
                    xs: "1.7rem",
                    md: "2.1rem",
                },
                lineHeight: 1.15,
                fontWeight: 700,
                letterSpacing: "-0.04em",
                color: colors.ink,
            }}
        >
            {children}
        </Typography>
    );
}

function TextBlock({ children }) {
    return (
        <Typography
            sx={{
                mb: 2,
                fontFamily: '"Nunito Sans", sans-serif',
                fontSize: {
                    xs: 16,
                    md: 17,
                },
                lineHeight: 1.8,
                color: colors.muted,
            }}
        >
            {children}
        </Typography>
    );
}

function Datenschutz() {
    return (
        <Box
            component="main"
            sx={{
                minHeight: "100vh",
                py: {
                    xs: 10,
                    md: 14,
                },
                background:
                    "linear-gradient(180deg, #fffaf2 0%, #f7f1e8 55%, #eef7fa 100%)",
            }}
        >
            <Container
                maxWidth={false}
                sx={{
                    width: "100%",
                    maxWidth: 980,
                    mx: "auto",
                    px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                    },
                }}
            >
                <Box
                    sx={{
                        p: {
                            xs: 3,
                            sm: 4,
                            md: 6,
                        },
                        borderRadius: {
                            xs: 5,
                            md: 7,
                        },
                        backgroundColor: colors.paper,
                        border: "1px solid rgba(155,118,83,0.15)",
                        boxShadow: "0 24px 80px rgba(78,54,30,0.09)",
                    }}
                >
                    <Typography
                        component="p"
                        sx={{
                            mb: 1.2,
                            fontFamily: '"Nunito Sans", sans-serif',
                            fontSize: 13,
                            fontWeight: 900,
                            letterSpacing: "0.17em",
                            textTransform: "uppercase",
                            color: colors.brown,
                        }}
                    >
                        Rechtliches
                    </Typography>

                    <Typography
                        component="h1"
                        sx={{
                            mb: 4,
                            fontFamily: '"Quicksand", sans-serif',
                            fontSize: {
                                xs: "2.6rem",
                                sm: "3.4rem",
                                md: "4.4rem",
                            },
                            lineHeight: 0.98,
                            fontWeight: 700,
                            letterSpacing: "-0.06em",
                            color: colors.ink,
                        }}
                    >
                        Datenschutz
                    </Typography>

                    <TextBlock>
                        Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir
                        behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
                        den gesetzlichen Datenschutzvorschriften sowie dieser
                        Datenschutzerklärung.
                    </TextBlock>

                    <TextBlock>
                        Diese Webseite verwendet nach aktuellem Stand keine Cookies, kein
                        Kontaktformular, keinen Newsletter und kein Tracking wie Google
                        Analytics oder vergleichbare Analysedienste.
                    </TextBlock>

                    <SectionTitle>1. Verantwortliche Stelle</SectionTitle>

                    <TextBlock>
                        Verantwortlich für die Datenverarbeitung auf dieser Webseite ist:
                        <br />
                        <br />
                        Hooksieler Lädchen
                        <br />
                        Claudia Don
                        <br />
                        Lange Straße 37
                        <br />
                        26434 Hooksiel
                        <br />
                        Deutschland
                    </TextBlock>

                    <TextBlock>
                        Telefon:{" "}
                        <Link
                            href="tel:+494425353"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            04425 - 353
                        </Link>
                        <br />
                        E-Mail:{" "}
                        <Link
                            href="mailto:info@hooksieler-laedchen.de"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,
                                wordBreak: "break-word",

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            info@hooksieler-laedchen.de
                        </Link>
                    </TextBlock>

                    <SectionTitle>2. Allgemeine Nutzung der Webseite</SectionTitle>

                    <TextBlock>
                        Die Nutzung dieser Webseite ist grundsätzlich ohne aktive Angabe
                        personenbezogener Daten möglich. Wenn Sie uns per Telefon oder
                        E-Mail kontaktieren, werden die von Ihnen mitgeteilten Daten
                        ausschließlich zur Bearbeitung Ihrer Anfrage verarbeitet.
                    </TextBlock>

                    <TextBlock>
                        Eine Weitergabe dieser Daten an Dritte erfolgt nicht ohne Ihre
                        Einwilligung, es sei denn, dies ist gesetzlich erlaubt oder
                        erforderlich.
                    </TextBlock>

                    <SectionTitle>3. Hosting und Server-Logfiles</SectionTitle>

                    <TextBlock>
                        Beim Aufruf dieser Webseite werden durch den Hostinganbieter
                        technisch notwendige Informationen verarbeitet, die Ihr Browser
                        automatisch übermittelt. Dazu können insbesondere IP-Adresse,
                        Datum und Uhrzeit der Anfrage, aufgerufene Seite, Referrer-URL,
                        Browsertyp, Browserversion, verwendetes Betriebssystem und
                        Hostname des zugreifenden Rechners gehören.
                    </TextBlock>

                    <TextBlock>
                        Die Verarbeitung dieser Daten erfolgt, um die Webseite technisch
                        bereitzustellen, die Stabilität und Sicherheit zu gewährleisten und
                        mögliche Störungen oder Missbrauch erkennen zu können.
                    </TextBlock>

                    <TextBlock>
                        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes
                        Interesse liegt in der sicheren und zuverlässigen Bereitstellung
                        dieser Webseite.
                    </TextBlock>

                    <SectionTitle>4. Kontaktaufnahme per E-Mail oder Telefon</SectionTitle>

                    <TextBlock>
                        Wenn Sie uns per E-Mail oder Telefon kontaktieren, verarbeiten wir
                        die von Ihnen übermittelten personenbezogenen Daten, zum Beispiel
                        Name, Telefonnummer, E-Mail-Adresse und Inhalt Ihrer Nachricht, zur
                        Bearbeitung Ihrer Anfrage.
                    </TextBlock>

                    <TextBlock>
                        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre
                        Anfrage mit vorvertraglichen Maßnahmen oder einem bestehenden
                        Vertragsverhältnis zusammenhängt. In allen anderen Fällen erfolgt
                        die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Das
                        berechtigte Interesse liegt in der Bearbeitung und Beantwortung
                        Ihrer Anfrage.
                    </TextBlock>

                    <SectionTitle>5. Keine Cookies und kein Tracking</SectionTitle>

                    <TextBlock>
                        Diese Webseite setzt nach aktuellem Stand keine eigenen Cookies und
                        verwendet keine Tracking- oder Analysewerkzeuge.
                    </TextBlock>

                    <TextBlock>
                        Sollten zukünftig Dienste eingesetzt werden, die Cookies,
                        Tracking-Technologien oder externe Inhalte verwenden, wird diese
                        Datenschutzerklärung entsprechend angepasst.
                    </TextBlock>

                    <SectionTitle>6. Keine Kontaktformulare und kein Newsletter</SectionTitle>

                    <TextBlock>
                        Auf dieser Webseite werden derzeit keine Kontaktformulare und kein
                        Newsletter angeboten. Es findet daher keine Verarbeitung
                        personenbezogener Daten über solche Funktionen statt.
                    </TextBlock>

                    <SectionTitle>7. Externe Links</SectionTitle>

                    <TextBlock>
                        Diese Webseite kann Links zu externen Webseiten enthalten, zum
                        Beispiel zum separaten Bestell-Shop. Für die Inhalte und die
                        Datenschutzpraktiken externer Webseiten ist der jeweilige Anbieter
                        verantwortlich.
                    </TextBlock>

                    <SectionTitle>8. Speicherdauer</SectionTitle>

                    <TextBlock>
                        Personenbezogene Daten werden nur so lange gespeichert, wie dies
                        für den jeweiligen Zweck erforderlich ist oder gesetzliche
                        Aufbewahrungspflichten bestehen.
                    </TextBlock>

                    <TextBlock>
                        Daten aus Kontaktanfragen werden gelöscht, sobald die Anfrage
                        abschließend bearbeitet wurde und keine gesetzlichen
                        Aufbewahrungspflichten entgegenstehen.
                    </TextBlock>

                    <SectionTitle>9. Ihre Rechte</SectionTitle>

                    <TextBlock>
                        Sie haben im Rahmen der gesetzlichen Vorgaben das Recht auf
                        Auskunft über die zu Ihrer Person gespeicherten Daten, das Recht
                        auf Berichtigung unrichtiger Daten, das Recht auf Löschung, das
                        Recht auf Einschränkung der Verarbeitung, das Recht auf
                        Datenübertragbarkeit sowie das Recht auf Widerspruch gegen
                        bestimmte Verarbeitungen.
                    </TextBlock>

                    <TextBlock>
                        Wenn eine Verarbeitung auf Ihrer Einwilligung beruht, können Sie
                        diese Einwilligung jederzeit mit Wirkung für die Zukunft
                        widerrufen.
                    </TextBlock>

                    <SectionTitle>10. Beschwerderecht bei einer Aufsichtsbehörde</SectionTitle>

                    <TextBlock>
                        Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu
                        beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
                        personenbezogenen Daten gegen Datenschutzrecht verstößt.
                    </TextBlock>

                    <SectionTitle>11. Sicherheit der Datenübertragung</SectionTitle>

                    <TextBlock>
                        Wir weisen darauf hin, dass die Datenübertragung im Internet,
                        beispielsweise bei der Kommunikation per E-Mail, Sicherheitslücken
                        aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff
                        durch Dritte ist nicht möglich.
                    </TextBlock>

                    <SectionTitle>12. Widerspruch gegen Werbe-E-Mails</SectionTitle>

                    <TextBlock>
                        Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
                        Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
                        Werbung und Informationsmaterialien wird hiermit widersprochen. Die
                        Betreiber der Seiten behalten sich rechtliche Schritte im Falle der
                        unverlangten Zusendung von Werbeinformationen, etwa durch
                        Spam-E-Mails, vor.
                    </TextBlock>

                    <SectionTitle>13. Aktualität dieser Datenschutzerklärung</SectionTitle>

                    <TextBlock>
                        Diese Datenschutzerklärung ist auf den aktuellen Stand der Webseite
                        ausgelegt. Wenn künftig zusätzliche Funktionen wie Kontaktformulare,
                        Newsletter, Karten, Social-Media-Plugins, Analyse-Tools oder
                        Cookies eingebunden werden, muss diese Datenschutzerklärung
                        entsprechend erweitert werden.
                    </TextBlock>
                </Box>
            </Container>
        </Box>
    );
}

export default Datenschutz;